"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeVariants = computeVariants;
exports.displayVariantComponentMap = void 0;

var _item = require("./item");

var _navigation = require("./navigation");

var _category = require("./category");

var displayVariantComponentMap = {
  nav: {
    BasicTabs: _navigation.NavigationBasicTabs,
    TabsCategorySidebar: _navigation.NavigationTabsCategorySidebar
  },
  category: {
    VerticalList: _category.CategoryVerticalList,
    Column: _category.CategoryColumn,
    VerticalCardRow: _category.CategoryVerticalCardRows,
    HorizontalCardRow: _category.CategoryHorizontalCardRows
  },
  item: {
    Basic: _item.ItemBasic,
    BasicCondensed: _item.ItemBasicCondensed,
    HorizontalCard: _item.ItemHorizontalCard,
    VerticalCard: _item.ItemVerticalCard
  }
};
exports.displayVariantComponentMap = displayVariantComponentMap;
var variantDependencyMap = {
  navToCategory: {
    BasicTabs: ['VerticalList', 'Column', 'VerticalCardRow', 'HorizontalCardRow'],
    TabsCategorySidebar: ['VerticalList', 'Column']
  },
  categoryToItem: {
    VerticalList: ['Basic', 'BasicCondensed', 'HorizontalCard'],
    Column: ['Basic', 'BasicCondensed'],
    VerticalCardRow: ['VerticalCard'],
    HorizontalCardRow: ['HorizontalCard']
  }
};

function computeVariants(_ref) {
  var navDisplay = _ref.navDisplay,
      categoryDisplay = _ref.categoryDisplay,
      itemDisplay = _ref.itemDisplay;
  var navToCategory = variantDependencyMap.navToCategory,
      categoryToItem = variantDependencyMap.categoryToItem;
  var allowedCategoryVariants = navToCategory[navDisplay];
  var computedCategoryDisplay = resolveVariant(allowedCategoryVariants, categoryDisplay);
  var allowedItemVariants = categoryToItem[computedCategoryDisplay];
  var computedItemDisplay = resolveVariant(allowedItemVariants, itemDisplay);
  return {
    navDisplay: navDisplay,
    categoryDisplay: computedCategoryDisplay,
    itemDisplay: computedItemDisplay
  };
}

function resolveVariant(options, userChoice) {
  return options.includes(userChoice) ? userChoice : randomChoice(options);
}

function randomChoice(arr) {
  return arr[Math.floor(arr.length * Math.random())];
}